import PublicLegalDocPage from './PublicLegalDocPage';

export default PublicLegalDocPage;
